import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { candidateJobQueryKeys } from '@/modules/candidates/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

interface HireCandidateJobParams {
  jobId: string;
  candidateId: string;
}

export const useHireCandidateJobMutation = () => {
  return useMutation({
    mutationFn: ({ jobId, candidateId }: HireCandidateJobParams) =>
      fetchClient.POST('/jobs/{jobId}/candidates/{candidateId}/hire', {
        params: {
          path: { jobId, candidateId },
        },
      }),
    onSettled: (_data, _error, variables) => {
      const { jobId, candidateId } = variables;
      invalidateQuery(candidateJobQueryKeys.lists(jobId))();
      invalidateQuery(candidateJobQueryKeys.detail(jobId, candidateId))();
    },
  });
};
